import { isPromise } from ".";

const pipe = (value, ...fns) => fns.reduce((val, fn) => fn(val), value);

export const pipeA = (value, ...fns) =>
	fns.reduce(
		(val, fn) => (isPromise(val) ? val.then(fn) : fn(val)), //
		value, //
	);

pipe.async = pipeA;

export default pipe;
